// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".authSection{padding:5vw 5vw 2vw 5vw !important;background:rgba(255,255,255,.8);min-height:100vh}.authSectionMobile{padding:5vw 5vw 2vw 5vw !important;background:rgba(255,255,255,.8);height:100%}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
